// extracted by mini-css-extract-plugin
export default {"phoneRow":"q3Tp_C3f","phone":"HFKZO6BX","withHover":"bUNftQ35","icon":"fPnrAPu_"};